import type { ReactElement } from 'react'

import { InfoTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { BulletedList } from '@/components/enlayouts/Ir/BulletedList'
import { BHeading } from '@/components/enlayouts/Ir/Heading'

export const InfoPage = () => {
  return (
    <Layout>
      <SectionTitle
        enTitleText="Basic Information"
        subTitleText=""
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <InfoTable />
      <Spacer h={{ sp: 50, pc: 80 }} />
      <BHeading>NOTICE</BHeading>
      <BulletedList listStyle="decimal">
        <li>
          For procedures such as changes in address, name, etc., designation of dividend
          receipt methods, and requests for the purchase of less-than-unit shares, please
          contact the securities company with which you have transactions.
        </li>
        <li>
          For various procedures related to shares recorded in a special account,
          Mitsubishi UFJ Trust and Banking Corporation serves as the account management
          institution. Therefore, please contact the account management institution for the
          special account (Mitsubishi UFJ Trust and Banking Corporation) mentioned above.
        </li>
      </BulletedList>
    </Layout>
  )
}

InfoPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Stock Information', path: '/en/ir/stock' },
    { name: 'Basic Information', path: '' },
  ]

  return (
    <>
      <Head
        title="Basic Information"
        description="Basic information on our stock."
        ogp={{ url: 'en/ir/stock/info' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
